import React, { useState } from "react";

import { Button, Typography, ListItem } from "@mui/material";
//Icons
import { ReactComponent as ErrorTriangleIcon } from "../../../../assets/icons/svg/error-triangle.svg";
import { ReactComponent as EditIcon } from "../../../../assets/icons/svg/edit.svg";
import { ReactComponent as GrabbableIcon } from "../../../../assets/icons/svg/bars.svg";
//Modal
import CustomModal from "../../../modal/CustomModal";
import EditIngredientModal from "./EditIngredientModal";

//Utils
import { decimalToFraction, convertToTitleCase } from "../../../../utils/recipe";

//DnD
import { Draggable } from "@hello-pangea/dnd";

//TO DO:
//Format data
//Display if missing key data (eg. ingredient name)
//Display if mapped ingredient
//Click to open edit ingredient modal (to edit or remove an ingredient)

const RecipeSectionIngredient = ({ ingredient, sectionIndex, ingredientIndex, errors }) => {
  //Hover state
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);
  const handleClick = () => setShowEditIngredientModal(true);
  const handleModalClose = () => setShowEditIngredientModal(false);

  //Modal State
  const [showEditIngredientModal, setShowEditIngredientModal] = useState(false);

  const handleModalMoveSection = () => {
    setShowEditIngredientModal(false);
  };

  //String formatting

  const formatAmountUnit = () => {
    let formattedAmount = "";
    let formattedUnit = "";

    if (ingredient.quantity && ingredient.quantity !== "") {
      formattedAmount = decimalToFraction(ingredient.quantity);
    }

    if (ingredient.unit && ingredient.unit !== "") {
      if (
        ingredient.unit !== "self" &&
        ingredient.unit !== "count" &&
        ingredient.unit !== "not_exact" &&
        ingredient.unit !== "to_taste"
      ) {
        formattedUnit = ingredient.unit;
      }
    }

    let showSpace = false;

    if (formattedUnit !== "") {
      showSpace = true;
    }

    return `${formattedAmount} ${formattedUnit}${showSpace ? " " : ""}`;
  };

  const formatIngredient = () => {
    //Convert ingredient data to a string for the top line
    if (ingredient.name && typeof ingredient.name === "string") {
      let formattedName =
        ingredient.name && ingredient.name !== "" ? convertToTitleCase(ingredient.name) : "Unknown Ingredient";

      return `${formattedName}`;
    } else {
      return "Unknown Ingredient";
    }
  };

  const formatState = () => {
    let formattedState = "";

    if (ingredient.state && typeof ingredient.state === "string" && ingredient.state !== "") {
      formattedState = convertToTitleCase(ingredient.state);
    }

    if (formattedState !== "") {
      return `, ${formattedState}`;
    }
  };

  //Top line -> amount unit name, state
  //Bottom line -> note
  //Verification/Error status
  return (
    <Draggable draggableId={`ingredient-${sectionIndex}-${ingredientIndex}`} index={ingredientIndex}>
      {(provided, snapshot) => (
        <ListItem
          ref={provided.innerRef}
          {...provided.draggableProps}
          className={`select-none list-item ${errors ? "marker:text-rose-600" : "marker:text-mainGreen"} py-1 px-2 ${
            snapshot.isDragging ? "bg-gray-100" : ""
          }`}
        >
          <div className="flex items-stretch w-full h-full">
            <div className="flex flex-grow items-center">
              <div
                className="cursor-pointer"
                onClick={handleClick}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <span className="flex flex-row items-center">
                  {errors && <ErrorTriangleIcon className="h-3 w-auto fill-rose-600 mr-2" />}
                  <Typography variant="subtitle1" className="font-medium">
                    <span className={`${errors ? "text-rose-600" : "text-primaryText"} font-normal`}>
                      {formatAmountUnit()}
                    </span>
                    <span
                      className={`${errors ? "text-rose-600" : isHovered ? "text-mainGreen" : "text-primaryText"}`}
                      style={{ wordBreak: "break-word", whiteSpace: "normal" }}
                    >
                      {formatIngredient()}
                    </span>
                    {ingredient.state !== "" && (
                      <span className={`font-normal italic ${errors ? "text-rose-600" : ""}`}>{formatState()}</span>
                    )}
                  </Typography>

                  {isHovered && <EditIcon className="h-3 fill-secondaryText ml-2" />}
                </span>
                {ingredient.note && ingredient.note !== "" && (
                  <Typography variant="body2" className={`text-secondaryText ${errors ? "text-rose-600/70" : ""}`}>
                    ({ingredient.note})
                  </Typography>
                )}
              </div>
              <div {...provided.dragHandleProps} className="flex-grow h-full cursor-move ml-2" />
              <div {...provided.dragHandleProps} className=" cursor-move flex items-center text-secondaryText-600">
                <GrabbableIcon className="h-3 fill-secondaryText" />
              </div>
            </div>
          </div>
          <CustomModal open={showEditIngredientModal} handleClose={handleModalClose} type="bottomToCentered">
            <EditIngredientModal
              ingredient={ingredient}
              sectionIndex={sectionIndex}
              ingredientIndex={ingredientIndex}
              handleModalClose={handleModalClose}
              onModalMove={handleModalMoveSection}
            />
          </CustomModal>
        </ListItem>
      )}
    </Draggable>
  );
};

export default RecipeSectionIngredient;
